import { FC, PropsWithChildren, ReactNode } from 'react';
import styles from './style.module.css';

type Props = PropsWithChildren<{
  title: ReactNode;
}>;

export const MedicalInstitutionIntroCardSection: FC<Props> = ({ title, children }) => {
  return (
    <div className={styles.root}>
      <h4 className={styles.title}>{title}</h4>
      <div className={styles.body}>{children}</div>
    </div>
  );
};
